import { epoch, utc } from '../../util/datetime';
import type { IObjectivePossibleAdverseChangesToFinancialSituationNatureOfPlannedChange } from './ObjectivePossibleAdverseChangesToFinancialSituationNatureOfPlannedChange.interface';

export default class ObjectivePossibleAdverseChangesToFinancialSituationNatureOfPlannedChange
  implements IObjectivePossibleAdverseChangesToFinancialSituationNatureOfPlannedChange {
  extendedUnpaidLeave: boolean;
  extendedUnpaidLeavePeriodOfImpact: string;
  extendedUnpaidLeaveFromDate: number;
  extendedUnpaidLeaveToDate: number;
  extendedUnpaidLeaveFinancialImpact: number;
  reducedIncome: boolean;
  reducedIncomePeriodOfImpact: string;
  reducedIncomeFromDate: number;
  reducedIncomeToDate: number;
  reducedIncomeFinancialImpact: number;
  endOfContract: boolean;
  endOfContractPeriodOfImpact: string;
  endOfContractFromDate: number;
  endOfContractToDate: number;
  endOfContractFinancialImpact: number;
  leavingEmployment: boolean;
  leavingEmploymentPeriodOfImpact: string;
  leavingEmploymentFromDate: number;
  leavingEmploymentToDate: number;
  leavingEmploymentFinancialImpact: number;
  increasedDebtRepayments: boolean;
  increasedDebtRepaymentsPeriodOfImpact: string;
  increasedDebtRepaymentsFromDate: number;
  increasedDebtRepaymentsToDate: number;
  increasedDebtRepaymentsFinancialImpact: number;
  largeExpenditure: boolean;
  largeExpenditurePeriodOfImpact: string;
  largeExpenditureFromDate: number;
  largeExpenditureToDate: number;
  largeExpenditureFinancialImpact: number;
  medicalTreatment: boolean;
  medicalTreatmentPeriodOfImpact: string;
  medicalTreatmentFromDate: number;
  medicalTreatmentToDate: number;
  medicalTreatmentFinancialImpact: number;
  other: boolean;
  otherComments: string;
  otherPeriodOfImpact: string;
  otherFromDate: number;
  otherToDate: number;
  otherFinancialImpact: number;

  static build = (
    data: IObjectivePossibleAdverseChangesToFinancialSituationNatureOfPlannedChange
  ) => new ObjectivePossibleAdverseChangesToFinancialSituationNatureOfPlannedChange(data);

  static blank = () =>
    new ObjectivePossibleAdverseChangesToFinancialSituationNatureOfPlannedChange();

  /**
   * Constructor
   * @param {IObjectivePossibleAdverseChangesToFinancialSituationNatureOfPlannedChange} data
   */
  constructor(
    data?: IObjectivePossibleAdverseChangesToFinancialSituationNatureOfPlannedChange
  ) {
    this.extendedUnpaidLeave = data?.extendedUnpaidLeave === true;
    this.extendedUnpaidLeavePeriodOfImpact = data?.extendedUnpaidLeavePeriodOfImpact || '';
    this.extendedUnpaidLeaveFromDate = data?.extendedUnpaidLeaveFromDate
      ? epoch(utc(data?.extendedUnpaidLeaveFromDate))
      : 0;
    this.extendedUnpaidLeaveToDate = data?.extendedUnpaidLeaveToDate
      ? epoch(utc(data?.extendedUnpaidLeaveToDate))
      : 0;
    this.extendedUnpaidLeaveFinancialImpact = parseFloat(
      data?.extendedUnpaidLeaveFinancialImpact || 0
    );
    this.reducedIncome = data?.reducedIncome === true;
    this.reducedIncomePeriodOfImpact = data?.reducedIncomePeriodOfImpact || '';
    this.reducedIncomeFromDate = data?.reducedIncomeFromDate
      ? epoch(utc(data?.reducedIncomeFromDate))
      : 0;
    this.reducedIncomeToDate = data?.reducedIncomeToDate
      ? epoch(utc(data?.reducedIncomeToDate))
      : 0;
    this.reducedIncomeFinancialImpact = parseFloat(data?.reducedIncomeFinancialImpact || 0);
    this.endOfContract = data?.endOfContract === true;
    this.endOfContractPeriodOfImpact = data?.endOfContractPeriodOfImpact || '';
    this.endOfContractFromDate = data?.endOfContractFromDate
      ? epoch(utc(data?.endOfContractFromDate))
      : 0;
    this.endOfContractToDate = data?.endOfContractToDate
      ? epoch(utc(data?.endOfContractToDate))
      : 0;
    this.endOfContractFinancialImpact = parseFloat(data?.endOfContractFinancialImpact || 0);
    this.leavingEmployment = data?.leavingEmployment === true;
    this.leavingEmploymentPeriodOfImpact = data?.leavingEmploymentPeriodOfImpact || '';
    this.leavingEmploymentFromDate = data?.leavingEmploymentFromDate
      ? epoch(utc(data?.leavingEmploymentFromDate))
      : 0;
    this.leavingEmploymentToDate = data?.leavingEmploymentToDate
      ? epoch(utc(data?.leavingEmploymentToDate))
      : 0;
    this.leavingEmploymentFinancialImpact = parseFloat(
      data?.leavingEmploymentFinancialImpact || 0
    );
    this.increasedDebtRepayments = data?.increasedDebtRepayments === true;
    this.increasedDebtRepaymentsPeriodOfImpact =
      data?.increasedDebtRepaymentsPeriodOfImpact || '';
    this.increasedDebtRepaymentsFromDate = data?.increasedDebtRepaymentsFromDate
      ? epoch(utc(data?.increasedDebtRepaymentsFromDate))
      : 0;
    this.increasedDebtRepaymentsToDate = data?.increasedDebtRepaymentsToDate
      ? epoch(utc(data?.increasedDebtRepaymentsToDate))
      : 0;
    this.increasedDebtRepaymentsFinancialImpact = parseFloat(
      data?.increasedDebtRepaymentsFinancialImpact || 0
    );
    this.largeExpenditure = data?.largeExpenditure === true;
    this.largeExpenditurePeriodOfImpact = data?.largeExpenditurePeriodOfImpact || '';
    this.largeExpenditureFromDate = data?.largeExpenditureFromDate
      ? epoch(utc(data?.largeExpenditureFromDate))
      : 0;
    this.largeExpenditureToDate = data?.largeExpenditureToDate
      ? epoch(utc(data?.largeExpenditureToDate))
      : 0;
    this.largeExpenditureFinancialImpact = parseFloat(
      data?.largeExpenditureFinancialImpact || 0
    );
    this.medicalTreatment = data?.medicalTreatment === true;
    this.medicalTreatmentPeriodOfImpact = data?.medicalTreatmentPeriodOfImpact || '';
    this.medicalTreatmentFromDate = data?.medicalTreatmentFromDate
      ? epoch(utc(data?.medicalTreatmentFromDate))
      : 0;
    this.medicalTreatmentToDate = data?.medicalTreatmentToDate
      ? epoch(utc(data?.medicalTreatmentToDate))
      : 0;
    this.medicalTreatmentFinancialImpact = parseFloat(
      data?.medicalTreatmentFinancialImpact || 0
    );
    this.other = data?.other === true;
    this.otherComments = data?.otherComments || '';
    this.otherPeriodOfImpact = data?.otherPeriodOfImpact || '';
    this.otherFromDate = data?.otherFromDate ? epoch(utc(data?.otherFromDate)) : 0;
    this.otherToDate = data?.otherToDate ? epoch(utc(data?.otherToDate)) : 0;
    this.otherFinancialImpact = parseFloat(data?.otherFinancialImpact || 0);
  }
}
